"use strict";
exports.__esModule = true;
exports.isCrawler = exports.isCrawlerUserAgent = void 0;
var web_crawler_service_1 = require("./web-crawler-service");
var singleton = new web_crawler_service_1.WebCrawlerService();
var isCrawlerUserAgent = function (topCrawlersToCheck) {
    return singleton.isCrawlerUserAgent(topCrawlersToCheck);
};
exports.isCrawlerUserAgent = isCrawlerUserAgent;
var isCrawler = function (userAgent, topCrawlersToCheck) {
    return singleton.isCrawler(userAgent, topCrawlersToCheck);
};
exports.isCrawler = isCrawler;
